import React, { useEffect, useState } from "react";
import {Container} from "react-bootstrap";

import {BasePage} from "pages/base-page";
import {MainTitle} from "components/styles";
import {FadeIn} from "components/fade-in";
import {useDelayedFadeIn} from "utils/animation-delay";
import { MarkdownRenderer } from "./markdown-renderer";

type Props = {
    path: string;
    title: string;
}

export const MarkdownContent: React.FC<Props> = ({path, title}: Props) => {
    const [markdown, setMarkdown] = useState<string | null>(null);
    const {nextDelay} = useDelayedFadeIn({});

    useEffect(() => {
      fetch(path)
        .then((response) => response.text())
        .then((text) => setMarkdown(text))
        .catch((err) => console.error("Failed to load markdown file:", err));
    }, [path]);
  
    return (
      <BasePage>
          <Container>
              <MainTitle className="mb-4">
                  <FadeIn nextDelay={nextDelay}>
                      {title}
                  </FadeIn>
              </MainTitle>
             {markdown ? <MarkdownRenderer markdown={markdown} /> : <div>Loading...</div>}
          </Container>
      </BasePage>
    );
  };